import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { Language } from '@lyceo/homi/settings/util-models';
import { SettingsPageActions } from './settings.actions';

export const SETTINGS_FEATURE_KEY: string = 'settings';

export interface SettingsState {
  language: Language;
}

export const initialSettingsState: SettingsState = {
  language: Language.NL,
};

const reducer: ActionReducer<SettingsState, Action> = createReducer(
  initialSettingsState,
  on(
    SettingsPageActions.languageChanged,
    (state, action): SettingsState => ({
      ...state,
      language: action.language,
    }),
  ),
);

export function settingsReducer(
  state: SettingsState | undefined,
  action: Action,
): SettingsState {
  return reducer(state, action);
}
